import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    ciudad: '',
    servicio: '',
    descripcion: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d76mkat4hjod66j2eto0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nombre: '',
          telefono: '',
          ciudad: '',
          servicio: '',
          descripcion: '',
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contacto" className="py-24 bg-[#F4F1EC]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Columna izquierda - Formulario */}
          <div className="flex flex-col">
            <h2 className="text-4xl lg:text-5xl font-heading font-bold text-[#1A1A2E] mb-4">
              Solicita Tu Cotización
            </h2>
            <p className="text-lg text-[#1A1A2E]/70 mb-8">Respuesta en menos de 24 horas</p>

            <form onSubmit={handleSubmit} data-readdy-form className="space-y-5">
              <div>
                <input
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  placeholder="Nombre completo"
                  required
                  className="w-full px-4 py-3.5 bg-white border border-gray-300 rounded-lg text-base focus:outline-none focus:border-[#C9A86A] transition-colors"
                />
              </div>

              <div>
                <input
                  type="tel"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  placeholder="Teléfono"
                  required
                  className="w-full px-4 py-3.5 bg-white border border-gray-300 rounded-lg text-base focus:outline-none focus:border-[#C9A86A] transition-colors"
                />
              </div>

              <div>
                <select
                  name="ciudad"
                  value={formData.ciudad}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3.5 bg-white border border-gray-300 rounded-lg text-base focus:outline-none focus:border-[#C9A86A] transition-colors"
                >
                  <option value="">Selecciona tu ciudad</option>
                  <option value="Saltillo">Saltillo</option>
                  <option value="Monterrey">Monterrey</option>
                  <option value="Arteaga">Arteaga</option>
                  <option value="Ramos Arizpe">Ramos Arizpe</option>
                  <option value="García">García</option>
                  <option value="San Pedro">San Pedro</option>
                  <option value="Otra">Otra</option>
                </select>
              </div>

              <div>
                <select
                  name="servicio"
                  value={formData.servicio}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3.5 bg-white border border-gray-300 rounded-lg text-base focus:outline-none focus:border-[#C9A86A] transition-colors"
                >
                  <option value="">Tipo de servicio</option>
                  <option value="Construcción">Construcción</option>
                  <option value="Carpintería">Carpintería</option>
                  <option value="Instalaciones Eléctricas">Instalaciones Eléctricas</option>
                  <option value="Acabados">Acabados</option>
                  <option value="Impermeabilización">Impermeabilización</option>
                  <option value="Mantenimiento">Mantenimiento</option>
                  <option value="Otro">Otro</option>
                </select>
              </div>

              <div>
                <textarea
                  name="descripcion"
                  value={formData.descripcion}
                  onChange={handleChange}
                  placeholder="Describe tu proyecto"
                  rows={4}
                  maxLength={500}
                  required
                  className="w-full px-4 py-3.5 bg-white border border-gray-300 rounded-lg text-base focus:outline-none focus:border-[#C9A86A] transition-colors resize-none"
                ></textarea>
                <p className="text-sm text-[#1A1A2E]/50 mt-2">
                  {formData.descripcion.length}/500 caracteres
                </p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full py-4 bg-[#C9A86A] text-[#1A1A2E] font-semibold rounded-lg hover:bg-[#B8935A] transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                {isSubmitting ? 'Enviando...' : 'Enviar Solicitud'}
              </button>

              {submitStatus === 'success' && (
                <div className="p-4 bg-green-50 border border-green-200 rounded-lg text-green-700">
                  ¡Gracias! Tu solicitud ha sido enviada. Te contactaremos pronto.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="p-4 bg-red-50 border border-red-200 rounded-lg text-red-700">
                  Hubo un error al enviar tu solicitud. Por favor, intenta de nuevo.
                </div>
              )}
            </form>
          </div>

          {/* Columna derecha - Información de contacto */}
          <div className="flex flex-col lg:justify-center gap-6">
            {/* WhatsApp */}
            <div className="bg-white rounded-xl p-7 hover:shadow-lg transition-shadow">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-whatsapp-fill text-white text-2xl"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg font-bold text-[#1A1A2E] mb-1">WhatsApp Directo</h3>
                  <a
                    href="https://wa.me/528447098387"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xl font-semibold text-[#1A1A2E] hover:text-[#25D366] transition-colors block mb-3"
                  >
                    (844) 709-8387
                  </a>
                  <a
                    href="https://wa.me/528447098387"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#25D366] text-white rounded-lg font-semibold hover:bg-[#1FA855] transition-colors whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-fill text-lg"></i>
                    Chatear Ahora
                  </a>
                </div>
              </div>
            </div>

            {/* Teléfono */}
            <div className="bg-white rounded-xl p-7 hover:shadow-lg transition-shadow">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 bg-[#1A1A2E] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-fill text-white text-2xl"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg font-bold text-[#1A1A2E] mb-2">Llámanos</h3>
                  <a
                    href="tel:+528447098387"
                    className="text-base font-semibold text-[#1A1A2E] hover:text-[#C9A86A] transition-colors block"
                  >
                    Saltillo: (844) 709-8387
                  </a>
                  <a
                    href="tel:+528120789333"
                    className="text-base font-semibold text-[#1A1A2E] hover:text-[#C9A86A] transition-colors block mb-2"
                  >
                    Monterrey: (812) 078-9333
                  </a>
                  <p className="text-sm text-[#7D7D7D]">Lun-Vie 8:00-18:00, Sáb 9:00-14:00</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}